export default "__VITE_ASSET__CzVvk914__"